import { create } from "zustand";
import { persist } from "zustand/middleware";

import { logoutSession } from "../api/auth";
import type { AuthUser as SharedAuthUser } from "@markeroo/shared";

export type AuthUser = SharedAuthUser;

export type AuthState = {
  accessToken: string | null;
  user: AuthUser | null;
  hydrated: boolean;
  login: (payload: { accessToken: string; user: AuthUser }) => void;
  setUser: (user: AuthUser | null) => void;
  logout: () => Promise<void>;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      hydrated: false,
      login: ({ accessToken, user }) => set({ accessToken, user, hydrated: true }),
      setUser: (user) => set((state) => ({ user, hydrated: true, accessToken: state.accessToken })),
      logout: async () => {
        try {
          await logoutSession();
        } catch {
          // Ignore logout API errors
        }
        set({ accessToken: null, user: null, hydrated: true });
      },
      clearAuth: () => set({ accessToken: null, user: null, hydrated: true }),
    }),
    {
      name: "markeroo-auth",
      partialize: (state) => ({ accessToken: state.accessToken, user: state.user }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setUser(state.user);
        }
      },
    }
  )
);
